import React, { Component } from 'react'
import './Invite.css'
import { withRouter } from '../../withRouter'
import Loading from '../commons/Loading'
import { auth, database, ref, get, set } from '../../firebase'

class Invite extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null
    }
    this.setGroup = this.setGroup.bind(this)
  }
  componentDidMount () {
    this.setGroup(this.props.match.params.id)
      .then(() => {
        this.props.history.replace('/g/' + this.props.match.params.id)
      })
      .catch((err) => {
        console.error(err)
        this.setState({
          error: 'Error, puede que el grupo al que estás intentando acceder no exista.'
        })
      })
  }
  setGroup (groupId) {
    return new Promise((resolve, reject) => {
      this.setState({
        activity: true
      })
      const userId = auth.currentUser.uid
      get(ref(database, 'grupos/index/' + groupId))
        .then((snap) => {
          if (snap.val()) {
            return get(ref(database, 'usuarios/grupos/' + userId + '/' + groupId))
          } else {
            reject(new Error('group-dont-exist'))
          }
        })
        .then((snap) => {
          if (snap.val()) {
            resolve()
          } else {
            return set(ref(database, 'grupos/miembros/' + groupId + '/' + userId), true)
          }
        })
        .then(() => {
          return set(ref(database, 'grupos/puntaje/' + groupId + '/global/' + userId), 0)
        })
        .then(() => {
          return set(ref(database, 'usuarios/grupos/' + userId + '/' + groupId), true)
        })
        .then(() => {
          resolve()
        })
        .catch((err) => reject(err))
    })
  }
  render () {
    console.log(this.state.error)
    return (
      <div className='invite'>
        {this.state.error ? <div className='invite__error'>
          <div className='invite__error__icon'>
            <i className='material-icons'>error</i>
          </div>
          <div className='invite__error__text'>
            {this.state.error}
          </div>
        </div> : <Loading />}
      </div>
    )
  }
}

export default withRouter(Invite, null)
